export const ACTIONS = {
  VIEW: 'view',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE: 'manage',
};
export const SUBJECTS = {
  ADMIN_PAGE: 'Admin Page',
  DONOR_PERSONAL_PAGE: 'Donor Personal Page',
  ADMIN_DONOR_PAGE: 'Admin Donor Page',
  RECIPIENT_PERSONAL_PAGE: 'Recipient Personal Page',
  ADMIN_RECIPIENT_PAGE: 'Admin Recipient Page',
};
